<canvas #container></canvas>
@if (config?.options?.plugins?.legend?.display === false) {
  <div class="labels">
    @for (item of chart?.legend?.legendItems; track item; let i = $index) {
      <div class="label" [ngClass]="{ hidden: !this.chart?.isDatasetVisible(item.datasetIndex ?? i) }">
        <div
          class="labelIndicator"
          [style]="{
            backgroundColor:
              customLegendColours && customLegendColours.length > (item.datasetIndex ?? i)
                ? customLegendColours[item.datasetIndex ?? i]
                : item.fillStyle,
          }"
        ></div>
        <div class="labelText" [style]="{ color: item.fontColor }">{{ item.text }}</div>
      </div>
    }
  </div>
}
